import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: "instant" }); // ✅ Ensures page starts at top instantly
      document.documentElement.scrollTop = 0; // ✅ Ensures full reset
      document.body.scrollTop = 0; // ✅ Fixes issue in Safari & older browsers
    }, 100); // ✅ Short delay ensures React finishes rendering before scrolling
  }, [pathname]);

  return null;
}
